import React, { useEffect, useState } from "react";
import Button from "@8x8/oxygen-button";
import Select from "@8x8/oxygen-select";
import styled from "styled-components";

const FlexContainer = styled.div`
  display: flex;
  gap: 40px;
`;

const SelectWrapper = styled.div`
  width: 300px;
`;

export const OptionEditor = ({
  value,
  options,
  onChange,
  onCreate,
  hasCreate,
}) => {
  const [currentOption, setCurrentOption] = useState({
    value: value,
    label: value,
  });
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    setOptionList(options);
    const current = options.find(
      (selectOption) => selectOption.value === value
    );
    setCurrentOption(current || options[0]);
  }, [value, options, onChange]);

  const commitSelectedValue = () => {
    if (currentOption["__isNew__"]) {
      onCreate(currentOption);
    } else {
      onChange(currentOption);
    }
  };

  return (
    <FlexContainer>
      <SelectWrapper>
        <Select
          size="small"
          value={currentOption}
          options={optionList}
          onChange={(selectedOptions) => {
            setCurrentOption(selectedOptions);
          }}
          isSearchable
          isClearable={false}
          isCreatable={hasCreate}
        />
      </SelectWrapper>
      <Button
        size="small"
        variant="success"
        isDisabled={value === currentOption.value}
        onClick={commitSelectedValue}
      >
        Save
      </Button>
    </FlexContainer>
  );
};
